import React from 'react';

const IconSecurity: React.FC<{className?: string}> =({className}) => {
    return (
        <svg className={className} width="22" height="26" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 0L0 3.63636V9.09091C0 14.1364 3.41333 18.8545 8 20C12.5867 18.8545 16 14.1364 16 9.09091V3.63636L8 0ZM8 9.99091H14.2222C13.7511 13.7364 11.3067 17.0727 8 18.1182V10H1.77778V4.81818L8 1.99091V9.99091Z" fill="#2BC5CD"/>
        </svg>
    );
}

export default IconSecurity;